
import { useState } from "react";
import CarCard from '../component/CarCard';
import AppointmentRequestModal from '../component/AppointmentRequestModal';
import type Car from "../../models/Car";


const ListingsView = ({ inventory, onSelectCar }: { inventory: Car[]; onSelectCar: (car: Car) => void }) => {
    const activeCars = inventory.filter((c: Car) => !c.archive);
    const [search, setSearch] = useState('');
    const [appointmentCar, setAppointmentCar] = useState<Car | null>(null);

    const filtered = activeCars.filter((c: Car) => 
        `${c.year} ${c.make} ${c.model}`.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="max-w-7xl mx-auto px-4 py-12 w-full">
            <div className="flex flex-col md:flex-row justify-between items-end mb-8 gap-4">
                <div>
                    <h1 className="text-4xl font-bold tracking-tight mb-2">Inventory</h1>
                    <p className="text-gray-500">Find your next vehicle from our curated selection.</p>
                </div>
                <input 
                    type="text" 
                    placeholder="Search Make, Model, or Year..." 
                    className="w-full md:w-96 border rounded-lg p-3 shadow-sm focus:ring-2 focus:ring-red-500 outline-none"
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
                {filtered.map((car: Car) => (
                    <CarCard 
                        key={car.id} 
                        car={car} 
                        onViewDetails={() => onSelectCar(car)}
                        onRequestAppointment={() => setAppointmentCar(car)}
                    />
                ))}
                {filtered.length === 0 && (
                    <div className="col-span-full py-12 text-center text-gray-400 bg-white rounded-lg shadow-sm">
                        No vehicles match your search.
                    </div>
                )}
            </div>

            {appointmentCar && (
                <AppointmentRequestModal
                    car={appointmentCar}
                    mode="guest-request"
                    onClose={() => setAppointmentCar(null)}
                />
            )}
        </div>
    );
};

export default ListingsView;
